import { Label } from '@visx/annotation';

interface Props {
  color: string;
  movement?: number;
  x: number;
  y: number;
  dy?: number;
  isNearLeftAxis?: boolean;
  showingMovement: boolean;
  backgroundColor?: string;
}

export const GlyphDot = ({
  color,
  movement = 0,
  x,
  y,
  dy,
  isNearLeftAxis,
  showingMovement,
  backgroundColor,
}: Props) => (
  <g>
    {showingMovement && (
      <Label
        x={isNearLeftAxis ? x - 8 : x + 40}
        y={y + (dy || 0)}
        title={`${movement === 0 ? '' : movement > 0 ? '+' : '-'}${Math.ceil(
          Math.abs(movement)
        )}%`}
        titleFontSize={12}
        titleFontWeight={400}
        fontColor={color}
        backgroundFill={backgroundColor || 'transparent'}
        backgroundPadding={4}
        backgroundProps={{ rx: 4, ry: 4 }}
        maxWidth={40}
      />
    )}
    <circle
      r={5}
      fill={color}
      stroke={'#fff'}
      strokeWidth={1}
      transform={`translate(${x} ${y})`}
    />
  </g>
);
